import React, { useContext, useEffect, useRef, useState } from 'react';
import { PaymentRequestButtonElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { toast } from 'react-toastify';
import { Post } from '../api/server';
import GlobalContext from '../context/store';
import moment from 'moment';

const BookingApplePay = ({ totalAmountDue, booking, user, totals, history, terms }) => {

  const { company } = useContext(GlobalContext);
  const stripe = useStripe();
  const elements = useElements();
  const [paymentRequest, setPaymentRequest] = useState(null);
  const [isApplePayAvailable, setIsApplePayAvailable] = useState(false);
  const [isGooglePayAvailable, setIsGooglePayAvailable] = useState(false);
  const termsRef = useRef(terms);

  useEffect(() => {
    termsRef.current = terms;
  }, [terms]);

  useEffect(() => {
    if (!stripe || !elements) {
      return;
    }

    if (totalAmountDue < 1 || typeof totalAmountDue === "undefined") {
      return;
    }

    const pr = stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'Dollhouse Mermaid Deposit',
        amount: Math.round(totalAmountDue * 100)
      },
      requestPayerName: true,
      requestPayerEmail: true,
      requestPayerPhone: true,
    });

    // Check the availability of the Payment Request API.
    pr.canMakePayment().then(result => {
      if (result) {
        setIsApplePayAvailable(result.applePay);
        setIsGooglePayAvailable(result.googlePay);
        setPaymentRequest(pr);
      }
    });

    pr.on('paymentmethod', async (e) => {
      if (!termsRef.current) {
        e.complete('fail');
        toast.error('You must accept the terms and conditions before proceeding with the payment.');
        return;
      }
      Post(`/bookings/frontend/createBooking`, {
        token: e.paymentMethod,
        company: company._id,
        first_name: e.payerName.split(' ')[0],
        last_name: e.payerName.split(' ')[1],
        phone: e.payerPhone,
        email: e.payerEmail,
        date: moment(booking?.startTime).format('YYYY-MM-DD'),
        startTime: moment(booking?.startTime).format('HH:mm'),
        service: booking?.service?._id,
        variation: booking?.variation?._id,
        address: user?.address,
        address2: user?.address2,
        city: user?.city,
        state: user?.state,
        zip: user?.zip,
        travel: booking?.travel,
        totals: totals
      }).then(async res => {
        // if (res.paymentIntent.status === 'requires_action') {
        //   stripe.confirmCardPayment(res.paymentIntent.client_secret, {
        //     payment_method: e.paymentMethod.id
        //   });
        // }
        e.complete('success');
        toast.success('Ticket(s) has been purchased successfully');
        history(`/booking/confirmation/${res._id}`)
      }).fail(err => {
        console.log(err);
        e.complete('fail');
        toast.error(err?.responseJSON?.payment_intent?.last_payment_error?.message || 'Something went wrong on our end. Ticket(s) has not been purchased. Please try again or contact support.');
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stripe, elements, company, totalAmountDue]);

  return (
    <>
      {paymentRequest && (
        <>
          {(isGooglePayAvailable || isApplePayAvailable) ? (
            <center>
              <PaymentRequestButtonElement options={{ paymentRequest }} />
            </center>
          ) : null}
        </>
      )}
    </>
  );
};

export default BookingApplePay;